var _title, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "rocket")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.4,3.68A15.89,15.89,0,0,0,21.47,7.9L7.91,21.46l4.86,4.85",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.32,
    cy: 15.76,
    r: 3.47,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.05,11c-1.45.42-3.49-.28-5.09-1.89A5.73,5.73,0,0,1,28,4.23",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38,20.86l5.53.6,7.85-7.85-5.11.52a4.82,4.82,0,0,0-2.92,1.38Z",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.14
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12.77 26.31 9.89 23.44 6.66 24.51 10.62 28.46",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4,3.68a15.89,15.89,0,0,1-4.22,13.93L17.62,31.17l-4.85-4.86",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.22,36.7l-.6-5.53,7.85-7.85L25,28.44a4.82,4.82,0,0,1-1.38,2.91Z",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.14
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12.77 26.31 15.64 29.19 14.57 32.42 10.62 28.46",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.14
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 5.94,
    y1: 29.19,
    x2: 3.02,
    y2: 32.11,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.91,
    y1: 31.17,
    x2: 3.11,
    y2: 35.97,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.89,
    y1: 33.14,
    x2: 6.97,
    y2: 36.06,
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}

export default SvgRocket;